import React from 'react';

import HookablePoint from '../HookablePoint';

export default function DrawPolygon(props: any) {
  const {
    points,
    lineColor,
    lineWidth,
    lineType,
    arn,
    fillingColor,
    hookProperties,
    labelFontSize,
  } = props;
  const [firstPoint, ...restPoints] = points;
  const d =
    `M ${firstPoint.x} ${firstPoint.y}` +
    restPoints.map((point: any) => `L ${point.x} ${point.y}`).join(' ') +
    ' Z';
  //For placing the label
  const sortedPoints = [...points].sort(
    (pointOne: any, pointTwo: any) => pointOne.y - pointTwo.y
  );
  let dashArray = '';
  if (lineType === 'dotted') {
    dashArray += '3';
  } else if (lineType == 'dashed') {
    dashArray += '10';
  } else {
    dashArray += '0';
  }
  return (
    <>
      <path
        d={d}
        stroke={lineColor}
        strokeWidth={lineWidth}
        strokeDasharray={dashArray}
        fill={fillingColor}
        pointerEvents="visibleStroke"
      />
      {points.map((point: any) => {
        return (
          <HookablePoint
            x={point.x}
            y={point.y}
            radius={2}
            id={point.pointLabel}
            fill={lineColor}
            stroke={lineColor}
            latitude={point.latitude}
            longitude={point.longitude}
            hookProperties={hookProperties}
          />
        );
      })}
      <text
        x={sortedPoints[0]?.x}
        y={sortedPoints[0]?.y - 10}
        textAnchor="middle"
        fill={lineColor}
        strokeWidth="1px"
        fontSize={labelFontSize || '0.5em'}
      >
        {arn?.toUpperCase()}
      </text>
    </>
  );
}
